module.exports = __webpack_public_path__ + "static/img/product_cp_2.438fb91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product_cp_2.png
// module id = s6YS
// module chunks = 1